(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vuetify-components"] = factory();
	else
		root["vuetify-components"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(13),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(14),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(15),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(16),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(12),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ConfirmBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Message__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StaticTextField__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StaticTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StaticTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SwitchField__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SwitchField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SwitchField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StaticTextArea__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StaticTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__StaticTextArea__);






var install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__ConfirmBox___default.a.name, __WEBPACK_IMPORTED_MODULE_0__ConfirmBox___default.a);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__Message___default.a.name, __WEBPACK_IMPORTED_MODULE_1__Message___default.a);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__StaticTextField___default.a.name, __WEBPACK_IMPORTED_MODULE_2__StaticTextField___default.a);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__SwitchField___default.a.name, __WEBPACK_IMPORTED_MODULE_3__SwitchField___default.a);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__StaticTextArea___default.a.name, __WEBPACK_IMPORTED_MODULE_4__StaticTextArea___default.a);
};

/* harmony default export */ __webpack_exports__["default"] = (install);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-confirm-box',
  model: {
    prop: 'display',
    event: 'hide'
  },
  props: {
    display: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: '确认？'
    },
    text: {
      type: String,
      required: false
    },
    width: {
      type: Number,
      required: false,
      default: 400
    },
    cancelText: {
      type: String,
      required: false,
      default: 'CANCEL'
    },
    okText: {
      type: String,
      required: false,
      default: 'OK'
    },
    cancel: {
      type: Function,
      required: false
    },
    ok: {
      type: Function,
      required: false
    },
    danger: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancelHandler: function cancelHandler() {
      this.hide();
      if (this.cancel) {
        this.cancel();
      }
    },
    okHandler: function okHandler() {
      this.hide();
      if (this.ok) {
        this.ok();
      }
    },
    hide: function hide() {
      this.$emit('hide', false);
    },
    color: function color(danger) {
      return danger ? 'red darken-1' : 'green darken-1';
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-message',
  model: {
    prop: 'value',
    event: 'close'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    timeout: {
      type: Number,
      default: 10
    },
    color: {
      type: String,
      default: 'info'
    },
    mode: {
      type: String,
      default: 'vertical'
    },
    closeText: {
      type: String,
      default: 'Close'
    }
  },
  data: function data() {
    return {
      display: false
    };
  },

  computed: {
    displayText: function displayText() {
      return this.text.replace('\n', '<br />');
    }
  },
  methods: {
    closeHandler: function closeHandler() {
      this.$emit('close');
    },
    inputHandler: function inputHandler() {
      this.$emit('close');
    }
  },
  watch: {
    value: function value(newValue) {
      this.display = newValue;
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-static-textarea',
  props: {
    label: {
      type: String
    },
    value: {
      required: true
    },
    hint: {
      type: String
    },
    counter: {
      type: Boolean
    },
    rows: {
      type: [Number, String]
    },
    persistentHint: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    progressColor: {
      type: String,
      default: 'primary'
    },
    progressHeight: {
      type: Number,
      default: 3
    }
  },
  computed: {
    displayText: function displayText() {
      return this.loading ? '' : this.value;
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-static-text-field',
  props: {
    label: {
      type: String
    },
    value: {
      required: true
    },
    hint: {
      type: String
    },
    counter: {
      type: Boolean
    },
    persistentHint: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    progressColor: {
      type: String,
      default: 'primary'
    },
    progressHeight: {
      type: Number,
      default: 3
    }
  },
  computed: {
    displayText: function displayText() {
      return this.loading ? '' : this.value;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-switch-field',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String
    },
    text: {
      type: String
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    value: {
      type: Boolean
    },
    readonly: {
      type: Boolean,
      default: false
    },
    progressColor: {
      type: String,
      default: 'primary'
    },
    progressWidth: {
      type: Number,
      default: 3
    }
  },
  methods: {
    changeHandler: function changeHandler() {
      if (!this.readonly) {
        this.$emit('change', !this.value);
      }
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'switch-field': true,
      'switch-field-readonly': _vm.readonly
    }
  }, [_c('label', {
    class: {
      'switch-label': true,
      'switch-label-active': !_vm.loading
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), (!_vm.loading) ? _c('v-switch', {
    staticClass: "switch-input",
    attrs: {
      "label": _vm.text,
      "input-value": _vm.value,
      "disabled": _vm.disabled || _vm.readonly
    },
    on: {
      "change": _vm.changeHandler
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [(_vm.loading) ? _vm._t("progress", [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": _vm.progressColor,
      "width": _vm.progressWidth
    }
  })]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.display,
      "persistent": "",
      "max-width": _vm.width
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.text) ? _c('v-card-text', [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": _vm.color(this.danger)
    },
    on: {
      "click": _vm.okHandler
    },
    nativeOn: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.okText) + "\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey lighten-1",
      "flat": ""
    },
    on: {
      "click": _vm.cancelHandler
    },
    nativeOn: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.cancelText) + "\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeout,
      "color": _vm.color,
      "multi-line": _vm.mode === 'multi-line',
      "vertical": _vm.mode === 'vertical'
    },
    on: {
      "input": _vm.inputHandler
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayText)
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": _vm.closeHandler
    }
  }, [_vm._v(_vm._s(_vm.closeText))])], 1)
},staticRenderFns: []}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-textarea', {
    staticClass: "v-static-textarea",
    attrs: {
      "value": _vm.displayText,
      "label": _vm.label,
      "hint": _vm.hint,
      "persistent-hint": _vm.persistentHint,
      "loading": _vm.loading,
      "counter": _vm.counter,
      "rows": _vm.rows,
      "readonly": "",
      "disabled": "",
      "auto-grow": ""
    },
    scopedSlots: _vm._u([{
      key: "progress",
      fn: function() {
        return [_c('v-progress-linear', {
          attrs: {
            "indeterminate": true,
            "color": _vm.progressColor,
            "height": _vm.progressHeight
          }
        })]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    staticClass: "v-static-text-field",
    attrs: {
      "value": _vm.displayText,
      "label": _vm.label,
      "counter": _vm.counter,
      "hint": _vm.hint,
      "persistent-hint": _vm.persistentHint,
      "loading": _vm.loading,
      "readonly": "",
      "disabled": ""
    },
    scopedSlots: _vm._u([{
      key: "progress",
      fn: function() {
        return [_c('v-progress-linear', {
          attrs: {
            "indeterminate": "",
            "color": _vm.progressColor,
            "height": _vm.progressHeight
          }
        })]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: []}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js